import React from "react";
import CircleProgress from "../../components/CircleProgress";
import HighestRankIcon from "../../components/HighestRankIcon"
import AnimatedNumber from "animated-number-react";
import {Typography} from "antd";

const HasMatching = WrappedClass => {

    return class HasMatching extends WrappedClass {
        matchedDisciplines(disciplines) {


            return TB.map(
                this.matching?.disciplines?.disciplines,
                discipline => {
                    return {
                        ...(TB.find(disciplines, ['id', discipline.discipline_id]) || {}),
                        ...discipline
                    }
                }
            );
        }

        metricScores()
        {
            if (!this.matching) {
                return []
            }
            let {
                disciplines = {},
                experience,
                industries,
                skills,
                brands,
                position_templates = {},
                services = {},
                overall
            } = this.matching;
            let experienceOverall = this.matching.position_templates ? {...position_templates} : {...experience}

            let metrics = [
                {
                    label: (<span><span>Skill</span><span>Expertise</span></span>),
                    percent: Math.ceil(skills.overall.percent),
                    score: (
                        <span>
                            <span>
                                <AnimatedNumber
                                    value={Math.ceil(skills.overall.percent)}
                                    formatValue={(value) => `${Number(value).toFixed(0)}%`}
                                    duration={1000}/>
                            </span>
                            <small>Match</small>
                        </span>
                    ),
                    matchHeader: `${skills.overall?.max_count > 0 ? Math.ceil(skills.overall.percent) : 0}% Skills Match`,
                    type: 'skills',
                    displayType: 'skill',
                    ...skills,
                },
                // {
                //     label: <span><span>Years</span><span>Experience</span></span>,
                //     percent: Math.ceil(experienceOverall?.percent),
                //     score: (
                //         <span>
                //             <span>
                //                 <AnimatedNumber
                //                     value={Math.ceil(experience?.percent)}
                //                     formatValue={(value) => `${Number(value).toFixed(0)}%`}
                //                     duration={1000}/>
                //             </span>
                //             <small>Match</small>
                //         </span>
                //     ),
                //     type: 'experience',
                //     matchHeader: `${Math.ceil(experienceOverall?.percent)}% Meets Requested`,
                //     ...experience,
                // },
                {
                    label: <span><span>Roles</span></span>,
                    percent: Math.ceil(disciplines?.percent),
                    score: (
                        <span>
                            <span>
                                <AnimatedNumber
                                    value={Math.ceil(disciplines?.percent)}
                                    formatValue={(value) => `${Number(value).toFixed(0)}%`}
                                    duration={1000}/>
                            </span>
                            <small>Match</small>
                        </span>
                    ),
                    type: 'disciplines',
                    displayType: 'role',
                    matchHeader: `${Math.ceil(disciplines?.percent)}% Meets Requested`,
                    ...experience,
                    ...disciplines,
                },

                {
                    label: <span><span>Industry</span><span>Experience</span></span>,
                    percent: industries.overall?.max_count > 0 ? Math.ceil(industries.overall.percent) : 0,
                    score: (
                        <span>
                            <span>
                                {industries.overall?.max_count > 0 ? Math.ceil(industries.overall.percent) : 0}%
                            </span>
                            <small>Match</small>
                        </span>
                    ),
                    matchHeader: `${industries.overall?.max_count > 0 ? Math.ceil(industries.overall.percent) : 0}% Industry Match`,
                    type: 'industries',
                    displayType: 'industry',
                    ...industries,
                },
                // ...(brands ? [
                //     {
                //         label: <span><span>Brands</span></span>,
                //         score: (
                //             <span>
                //                 <span>
                //                     {Math.ceil(brands.percent || 0)}%
                //                 </span>
                //                 <small>Match</small>
                //             </span>
                //         ),
                //         matchHeader: `${Math.ceil(brands.percent || 0)}% Brand Match`,
                //         type: 'brands',
                //         ...brands,
                //     }
                // ] : [])
            ];

            return TB.map(metrics, metric => {
                metric.renderProgress = (includeRank = true) => this.progressCircleForMetric(metric, includeRank);
                return metric;
            })
        }

        matchScoresForCriteria(criteria = {}) {


            console.log('matchScoresForCriteria', {metrics: this.metrics,criteria});


            let matchScores = this.metrics;
            if (matchScores.industries_brands_match) {
                matchScores.industries_brands_match.total_max_count = (matchScores.industries_brands_match.brands_max_count || 0) +
                    (matchScores.industries_brands_match.industries_max_count || 0)
                matchScores.industries_brands_match.total_count = (matchScores.industries_brands_match.brands_count || 0) +
                    (matchScores.industries_brands_match.industries_count || 0)
            }

            const seniorExp = criteria.wants_senior_experience || criteria.experience?.senior;
            const intermediateExp = criteria.wants_intermediate_experience || criteria.experience?.intermediate;
            const juniorExp = criteria.wants_junior_experience || criteria.experience?.junior;

            const hasExperienceCriteria = seniorExp || intermediateExp || juniorExp;

            let criteriaByImportance = TB.cloneDeep(criteria);
            for (let criteriaType of ['industries', 'skills']) {
                if (criteria[criteriaType]?.length) {
                    for(let[level, importanceLabel] of Object.entries(laravel.importance_levels)) {
                        criteriaByImportance[`${TB.snakeCase(importanceLabel)}_${criteriaType}`] = TB.filter(criteria[criteriaType], ['importance', parseInt(level)]);
                        // console.log(`matchScoresForCriteria${importanceLabel}`, criteria[criteriaType],parseInt(level),)
                    }
                }
            }
            const mapCriteriaForImportance = (criteriaType, importance = 'nice_to_have', profiledItems) => {

                importance = TB.snakeCase(importance)

                let criteriaImportance = `${importance}_${criteriaType}`;

                // console.log('mapCriteriaForImportance', criteriaByImportance[criteriaImportance])

                if (!profiledItems.length &&
                    TB.isArray(criteriaByImportance[criteriaImportance]) &&
                    !criteriaByImportance[criteriaImportance].length) return false;

                profiledItems = TB.keyBy([...profiledItems], 'id');

                if (TB.isArray(criteriaByImportance[criteriaImportance]) && criteriaByImportance[criteriaImportance].length) {

                    let matched = [];
                    let unmatched = [];

                    for (let item of criteriaByImportance[criteriaImportance]) {
                        if (parseInt(item.id || item.value) && profiledItems[parseInt(item.id || item.value)]) {
                            matched.push(profiledItems[parseInt(item.id || item.value)])
                        } else {
                            unmatched.push(item);
                        }
                    }

                    // console.log('mapCriteriaForImportance', matched, unmatched)
                    matched = TB.filter([...matched], match => match);
                    unmatched = TB.filter([...unmatched], unmatch => unmatch);

                    return {
                        ...(this.matching?.[criteriaType]?.[importance] || {}),
                        matched,
                        unmatched
                    }
                }
                return false;
            }
            const matchingByProperty = (prop, profileProps = []) => {
                if (prop === 'skills' || prop === 'industries') {
                    let matchScore = {};

                    let importanceLevels = TB.values(laravel.importance_levels).reverse();

                    for (let level of importanceLevels) {

                        let matchName = TB.snakeCase(level)

                        let match = mapCriteriaForImportance(prop, level, profileProps);

                        // console.log('matchingByProperty', match)
                        if (match) {
                            matchScore[matchName] = match
                        }
                    }

                    return matchScore;
                }
                if (!criteria[prop]?.length) {
                    return [];
                }
                let userPropsIds = TB.map(profileProps, 'id')
                let items = TB.map(criteria[prop], item => {
                    let match = userPropsIds?.includes(item.id);
                    if (match) {
                        return {
                            ...(TB.find(profileProps, [
                                'id',
                                parseInt(item.id)
                            ])),
                            match
                        }
                    }
                    return {
                        ...item,
                        match
                    }
                });
                items = TB.orderBy(items, 'match', 'desc')

                return items

            }

            const matchingExp = () => {
                // console.log('matchingExp', talentCriteria.disciplines);

                const expMultiSelectMapping = {
                    junior: 80,
                    intermediate: 95,
                    senior: 100,
                }
                let matched_scores = [];

                if (seniorExp) {
                    matched_scores.push(expMultiSelectMapping.senior)
                }
                if (intermediateExp) {
                    matched_scores.push(expMultiSelectMapping.intermediate)
                }
                if (juniorExp) {
                    matched_scores.push(expMultiSelectMapping.junior)
                }

                let talentExpOptions = laravel.talent_experience_levels;

                let disciplines = TB.map(criteria.disciplines || [], discipline => {
                    let match = TB.find(TB.filter(this.talent_disciplines, dis => dis.is_approved || !TB.isDefined(dis.is_approved)), [
                        'id',
                        parseInt(discipline.id)
                    ]);

                    let meetsCriteria = false;
                    let selectedScore = false;
                    let talentScore = false;
                    if (match && match?.is_approved && match?.talent_score) {
                        talentScore = match.talent_score || parseInt(TB.first(TB.keys(talentExpOptions)))

                        meetsCriteria =  matched_scores.includes(talentScore);

                        selectedScore = talentExpOptions[talentScore];
                    }
                    if (!hasExperienceCriteria) {
                        meetsCriteria = true;
                    }
                    return {
                        match: !!match,
                        meets_criteria: meetsCriteria,
                        total_experience: talentScore,
                        total_experience_label: selectedScore ? `${selectedScore.level} (${selectedScore.label})` : (<Typography.Text type="secondary" className="italic">None</Typography.Text>),
                        ...discipline
                    }
                })
                disciplines = TB.orderBy(disciplines, 'match', 'desc')

                if (disciplines.length > 10) {
                    disciplines = TB.filter(disciplines, ['match', true])
                }
                return TB.orderBy(disciplines, 'meets_criteria', 'desc')
            }

            return {
                overall_match: matchScores.overall_match,
                industries_brands_match: {
                    ...(matchScores?.industries_brands_match || {}),
                    industries: matchingByProperty('industries', this.industries_worked || []),
                    brands: matchingByProperty('brands', this.brands || []),
                },
                skills_match: {
                    ...(matchScores?.skills_match || {}),
                    skills: matchingByProperty('skills', this.skills || []),
                },
                experience_match: {
                    ...(matchScores?.experience_match || {}),
                    disciplines: matchingExp(),
                    experience: {
                        senior: seniorExp,
                        intermediate: intermediateExp,
                        junior: juniorExp,
                    },
                }
            }
        }

        experienceRanges(matching) {
            let ranges = [];


            TB.mapKeys(laravel.talent_scoring_options, (option, key) => {

                let range = {
                    title: this.constructor.experienceScoreTitle(key),
                    label: this.constructor.experienceScoreLabel(key),
                };

                if (TB.isDefined(matching)) {
                    range.meets_criteria = matching <= key;
                }

                ranges.push(range);
            })

            return TB.uniqBy(ranges, 'title');
        }

        static experienceScoreTitle(score) {
            switch (score) {
                default:
                case 1:
                    return 'Entry Level'
                case 2:
                    return 'Accomplished'
                case 3:
                    return 'Advanced'
                case 4:
                case 5:
                    return 'Expert'
            }
        }
        static experienceScoreLabel(score) {
            switch (score) {
                default:
                case 1:
                    return '0-1 Years'
                case 2:
                    return '2-5 Years'
                case 3:
                    return '6-10 Years'
                case 4:
                case 5:
                    return '11+ Years'
            }
        }

        progressCircleForMetric(metric, includeRank = true) {
            let {
                percent,
                max_count
            } = metric.overall || {};

            let disabled = false;
            // if(metric.type !== 'experience') {
                disabled = TB.isDefined(max_count) && max_count === 0;
            //}

            return (
                <CircleProgress
                    className="metric-circle"
                    progress={disabled ? 0 : metric.percent}
                    strokeWidth={7}>
                    {includeRank && !disabled && metric.is_ranked_highest && (
                        <HighestRankIcon/>
                    )}
                    {!disabled ? (
                        <p className={metric.is_ranked_highest ? 'has-rank' : ''}>
                            <span>
                                <span>
                                    {metric.overall.max_count > 0 ? Math.ceil(metric.percent) : 0}%
                                </span>
                                <small>Match</small>
                            </span>
                        </p>
                    ): (
                        <p>No Criteria Set</p>
                    )}
                </CircleProgress>
            )
        }
    }

}


export default HasMatching